import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbTimeStruct, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RecurrenceConsoleService } from '../../Services/RecurrenceConsoleService';
import { LocationLookup, GenericMaster, CallDescriptionLookup, GenericMaster_String } from '../../Models/GlobalEntities';
import { RecurrenceFilterModel } from '../../Models/RequestModels';
import { RECURRENCE_ROOMSTATUS } from '../../Models/EnumModels';
import * as alasql from 'alasql';
import * as _ from 'lodash';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'RecurrenceFilter',
    templateUrl: './RecurrenceFilter.html',
})

export class RecurrenceFilter extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;

    @ViewChild('CallDescriptions') CallDescriptions: NgSelectComponent;
    @ViewChild('Locations') Locations: NgSelectComponent;
    @ViewChild('Departments') Departments: NgSelectComponent;

    lstLocations: Array<LocationLookup> = [];
    lstCallDescriptions: Array<CallDescriptionLookup> = [];
    lstDepartments: Array<GenericMaster> = [];
    SelectedProperty: number;
    RequestModel: RecurrenceFilterModel;

    @Output() ApplyFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public recurrenceConsoleService: RecurrenceConsoleService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.CallDescriptions.virtualScroll = true;
        this.Locations.virtualScroll = true;
        this.Departments.virtualScroll = true;
    }

    Open(Model: RecurrenceFilterModel) {
        this.RequestModel = Model;
        let objProp = this.masterService.Cache_PropertyMainMasters.getValue(this.RequestModel.Properties[0]);

        if (this.CheckPropertyChange() == false) {
            let ngbModalOptions: NgbModalOptions = {
                backdrop : 'static',
                size: 'lg', 
                centered: true
            };
            this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
            return;
        }

        this.SelectedProperty = this.RequestModel.Properties[0];
        this.lstCallDescriptions = alasql('Select * From ? Where Id In (SELECT COLUMN DISTINCT CallDescriptionId FROM ?)', [objProp.CallDescriptions, this.recurrenceConsoleService.Cache_RecurrenceData]);
        this.lstLocations = alasql('Select * From ? Where Id In (SELECT COLUMN DISTINCT LocationId FROM ?)', [objProp.Location, this.recurrenceConsoleService.Cache_RecurrenceData]);
        this.lstDepartments = alasql('Select * From ? Where Id In (SELECT COLUMN DISTINCT DepartmentId FROM ?)', [objProp.Dept, this.recurrenceConsoleService.Cache_RecurrenceData]);
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);

    }

    CheckPropertyChange(): boolean {
        if (this.RequestModel.Properties[0] != this.SelectedProperty) {
            return true;
        }
        return false;
    }

    setEndPattern(code: number, value: boolean) {
        if (value) {
            this.RequestModel.lstEndPattern.push(code);
        }
        else {
            _.pull(this.RequestModel.lstEndPattern, code);
        }
        console.log(this.RequestModel);
    }

    OnFilterApply() {
        this.ModalRef.close();
        this.ApplyFilter.emit(true);
    }
    
    selectAll(model:NgModel){
        const selected = this.lstDepartments.map(item => item.Id); 
        model.update.emit(selected);
    }

    OnClear(): void {
        let propId= this.RequestModel.Properties[0];
        //this.RequestModel = new RecurrenceFilterModel();
        this.RequestModel.ClearFilter();
        this.RequestModel.Properties[0] = propId;
        this.ApplyFilter.emit(true);
        this.ModalRef.close();
    }
}
